import BattconService from "@/services/battConService";
import { useRoute } from "vue-router";
import { ref } from "vue";

export const ref_installer_key = ref("");

// Whitelabel Service - Domain-based branding configuration
class WhitelabelService {
  constructor() {
    // this.currentPath = this.getCurrentPath();
    // this.config = this.loadConfiguration();
    this.installer_key = null;
    this.whitelabel = false;
    this.whitelabelLanguage = "nl";
    this.currentConfig = null;
    this.readyWaiters = [];
    this.styleElement = document.createElement("style");

    //if (router.currentRoute.query.themetest == "true") {
    if (
      new URLSearchParams(window.location.search).get("themetest") == "true"
    ) {
      const trustedSource = (origin) =>
        origin === "https://luxus-tool.nl" ||
        origin ===
          "https://red-island-0f7a1ca03-staging.westeurope.4.azurestaticapps.net" ||
        origin ===
          "https://red-island-0f7a1ca03-development.westeurope.4.azurestaticapps.net" ||
        origin === "http://localhost" ||
        origin.startsWith("http://localhost:") ||
        origin === "http://127.0.0.1" ||
        origin.startsWith("http://127.0.0.1:") ||
        origin === "http://[::1]" ||
        origin.startsWith("http://[::1]:");

      window.addEventListener("message", (event) => {
        if (
          event.data?.type === "apply-css" &&
          typeof event.data.css === "string" &&
          trustedSource(event.origin)
        ) {
          this.styleElement.textContent = event.data.css;
        }
      });
    }
  }

  loadRoute() {
    let route = useRoute();
    if (route) {
      if (this.installer_key === route.params.installer_key) return;
      this.installer_key = route.params.installer_key;
      if (this.installer_key == undefined) {
        this.installer_key = "alius";
        this.whitelabel = false;
      } else {
        this.whitelabel = true;
      }

      ref_installer_key.value = this.installer_key;

      this.getConfigCall = BattconService.getBattConConfig(
        this.installer_key,
        route.query.themetest == "true",
      );
      this.getConfigCall.then(
        (config) => {
          this.currentConfig = config;
          if (config.websiteTitle) document.title = config.websiteTitle;
          if (this.styleElement) this.styleElement.remove();
          this.styleElement.textContent = config.themeCSS;
          document.head.append(this.styleElement);
          this.whitelabelLanguage = config.language.toLowerCase();
          for (const readyWaiter of this.readyWaiters) {
            readyWaiter.resolve();
          }
          this.readyWaiters = [];
        },
        () => {
          for (const readyWaiter of this.readyWaiters) readyWaiter.reject();
          this.readyWaiters = [];
        },
      );
    }
  }

  getConfig = function () {
    return this.currentConfig ? this.currentConfig : {};
  };

  getInstallerKey = function () {
    return this.installer_key;
  };

  isWhitelabel = function () {
    return this.whitelabel;
  };

  isWHES = function () {
    return this.installer_key.toUpperCase().startsWith("WHES");
  };

  getBrandName() {
    return this.installer_key;
  }

  getAlternativeThankyouPageUrl = function () {
    return this.currentConfig
      ? this.currentConfig.alternativeThankyouPageUrl
      : null;
  };

  getBatteryBrand() {
    return this.currentConfig && this.currentConfig.batteryBrand
      ? this.currentConfig.batteryBrand
      : 0;
  }

  ready() {
    if (this.currentConfig == null)
      return new Promise((resolve, reject) => {
        this.readyWaiters.push({ resolve, reject });
      });
    else return Promise.resolve();
  }

  // getCurrentPath() {
  //   if (typeof window !== "undefined") {
  //     const path = window.location.pathname.toLowerCase();
  //     // Extract the first path segment (e.g., "/luxus/wizard" → "luxus")
  //     const pathSegments = path.split("/").filter(Boolean);
  //     if (pathSegments[0] && pathSegments[0].startsWith("whes"))
  //       return "whes";
  //     return pathSegments[0] || "default";
  //   }
  //   return "default"; // fallback for SSR/testing
  // }

  loadConfiguration() {
    // Path-specific configurations
    const configurations = {
      // Default/Fallback configuration
      // Luxus whitelabel
      default: {
        brand: {
          name: "Luxus",
          logo: "/assets/logos/luxus-logo.png",
          favicon: "/assets/favicons/luxus-favicon.ico",
        },
        theme: {
          primary: "#bd7eee",
          secondary: "#ffcb7e",
          background: "#fff4eb",
          foreground: "#ffffff",
          gradient: {
            from: "#2c1945",
            to: "#bd7eee",
          },
          // Step-specific colors
          step1: {
            primary: "#BD7EEE",
            secondary: "#2C1945",
            gradient: {
              from: "#BD7EEE",
              to: "#FFCB7E",
            },
            buttonText: {
              primary: "white",
              secondary: "white",
            },
            consultationText: "black",
            progressBar: "#ffcb7e",
          },
        },
        colors: {
          purple: {
            primary: "#1f2937",
            dark: "#111827",
            light: "#f9fafb",
          },
        },
        fonts: {
          primary: "Inter, Arial, sans-serif",
        },
        language: {
          preferred: "nl", // Primary market preference
          fallback: "en",
          available: ["nl", "en"],
        },
      },

      battcon: {
        brand: {
          name: "Batterij-berekenen.nl",
          logo: "/assets/battery.png", // Using battery image as temporary logo
          favicon: "/favicon.ico",
        },
        theme: {
          primary: "#bd7eee",
          secondary: "#f59e0b",
          gradient: {
            from: "#2c1945",
            to: "#bd7eee",
          },
          // Step-specific colors
          step1: {
            primary: "#BD7EEE", // Orange for Step1
            secondary: "#2C1945", // Purple for Step1 secondary
            gradient: {
              from: "#BD7EEE",
              to: "#FFCB7E",
            },
            buttonText: {
              primary: "white",
              secondary: "white",
            },
            consultationText: "black", // Consultation box text color
            progressBar: "#bd7eee", // Progress bar color
          },
        },
        colors: {
          purple: {
            primary: "#bd7eee",
            dark: "#2c1945",
            light: "#f3e8ff",
          },
        },
        fonts: {
          primary: "PPMori, Arial, sans-serif",
        },
        language: {
          preferred: "nl", // Primary market preference
          fallback: "en",
          available: ["nl", "en"],
        },
      },

      // Luxus whitelabel
      luxus: {
        brand: {
          name: "Luxus",
          logo: "/assets/logos/luxus-logo.png",
          favicon: "/assets/favicons/luxus-favicon.ico",
        },
        theme: {
          primary: "#1f2937", // Dark gray
          secondary: "#f59e0b", // Amber
          gradient: {
            from: "#1f2937",
            to: "#374151",
          },
          // Step-specific colors
          step1: {
            primary: "#f59e0b", // Amber for Step1
            secondary: "#1f2937", // Dark gray for Step1 secondary
            gradient: {
              from: "#f59e0b",
              to: "#f97316",
            },
            buttonText: {
              primary: "white",
              secondary: "white",
            },
            consultationText: "black", // Consultation box text color
            progressBar: "#f59e0b", // Progress bar color
          },
        },
        colors: {
          purple: {
            primary: "#1f2937",
            dark: "#111827",
            light: "#f9fafb",
          },
        },
        fonts: {
          primary: "Inter, Arial, sans-serif",
        },
        language: {
          preferred: "en", // International preference
          fallback: "nl",
          available: ["nl", "en"],
        },
      },

      // Markhorst BattCon partner
      markhorst: {
        brand: {
          name: "Markhorst",
          logo: "/assets/logos/markhorst.webp",
          favicon: "/assets/favicons/markhorst-favicon.ico",
        },
        theme: {
          primary: "#0E3751",
          secondary: "#f59e0b",
          background: "#ededed",
          foreground: "#ffffff",
          gradient: {
            from: "#521B6B",
            to: "#CD0A86",
          },
          // Step-specific colors
          step1: {
            primary: "#CD0A86",
            secondary: "#FFF",
            gradient: {
              from: "#C20580",
              to: "#832083",
            },
            buttonText: {
              primary: "white",
              secondary: "black", // Black text on white secondary button
            },
            consultationText: "white", // Consultation box text color
            progressBar: "#3AB649", // Progress bar color
          },
        },
        colors: {
          purple: {
            primary: "#0ea5e9",
            dark: "#BD7EEE80",
            light: "#FFF",
          },
        },
        fonts: {
          primary: "PPMori, Arial, sans-serif", // Keep same font as BattCon
        },
        language: {
          preferred: "nl", // Dutch market
          fallback: "en",
          available: ["nl", "en"],
        },
      },

      // Green Energy partner
      greenenergy: {
        brand: {
          name: "Green Energy",
          logo: "/assets/logos/green-logo.png",
          favicon: "/assets/favicons/green-favicon.ico",
        },
        theme: {
          primary: "#059669", // Green
          secondary: "#059efb",
          gradient: {
            from: "#064e3b",
            to: "#059669",
          },
          // Step-specific colors
          step1: {
            primary: "#059e0b", // Orange for Step1
            secondary: "#059669", // Green for Step1 secondary
            gradient: {
              from: "#059e0b",
              to: "#f97316",
            },
            buttonText: {
              primary: "white",
              secondary: "white",
            },
            consultationText: "black", // Consultation box text color
            progressBar: "#059669", // Progress bar color
          },
        },
        colors: {
          purple: {
            primary: "#059669",
            dark: "#064e3b",
            light: "#ecfdf5",
          },
        },
        fonts: {
          primary: "Roboto, Arial, sans-serif",
        },
      },

      // WHES partner
      whes: {
        brand: {
          name: "WHES",
          logo: "/assets/battery.png", // Using battery image as temporary logo
          favicon: "/assets/favicons/whes-favicon.ico",
        },
        theme: {
          // #004C9D (tech blue)
          // #008CD4 (sky blue)
          // #79BE76 (warm green)
          primary: "#1a1a1a", // Dark/black from header
          secondary: "#79BE76", // Green accent color
          background: "#ffffff",
          foreground: "#ededed",
          gradient: {
            from: "#1a1a1a",
            to: "#374151",
          },
          // Step-specific colors
          step1: {
            primary: "#79BE76", // Green for Step1 primary button
            secondary: "#1a1a1a", // Dark for Step1 secondary
            gradient: {
              from: "#79BE76",
              to: "#16a34a",
            },
            buttonText: {
              primary: "white",
              secondary: "white",
            },
            consultationText: "black", // Consultation box text color
            progressBar: "#79BE76", // Green progress bar
          },
        },
        colors: {
          purple: {
            primary: "#79BE76", // Use green instead of purple
            dark: "#1a1a1a",
            light: "#f9fafb", // Light gray background
          },
        },
        fonts: {
          primary: "Poppins, Arial, sans-serif", // Based on their website font
        },
      },
    };

    // Find matching configuration or use default
    const pathConfig =
      configurations[this.currentPath] || configurations["default"];

    // Set CSS custom properties for dynamic theming
    this.setCSSVariables(pathConfig);

    return pathConfig;
  }

  // Helper function to convert hex color to CSS filter
  hexToFilter(hex) {
    // Remove # if present
    hex = hex.replace("#", "");

    // Convert hex to RGB
    const r = parseInt(hex.substr(0, 2), 16);
    const g = parseInt(hex.substr(2, 2), 16);
    const b = parseInt(hex.substr(4, 2), 16);

    // Simple approximation for common colors
    // This is a simplified version - for production, you might want a more accurate conversion
    if (hex.toLowerCase() === "bd7eee") {
      // Purple
      return "brightness(0) saturate(100%) invert(74%) sepia(56%) saturate(1906%) hue-rotate(258deg) brightness(95%) contrast(102%)";
    } else if (hex.toLowerCase() === "1f2937") {
      // Dark gray
      return "brightness(0) saturate(100%) invert(13%) sepia(11%) saturate(1210%) hue-rotate(181deg) brightness(92%) contrast(89%)";
    } else if (
      hex.toLowerCase() === "0ea5e9" ||
      hex.toLowerCase() === "0e3751"
    ) {
      // Blue
      return "brightness(0) saturate(100%) invert(44%) sepia(75%) saturate(2270%) hue-rotate(213deg) brightness(97%) contrast(101%)";
    } else if (hex.toLowerCase() === "059669") {
      // Green
      return "brightness(0) saturate(100%) invert(58%) sepia(69%) saturate(451%) hue-rotate(121deg) brightness(96%) contrast(85%)";
    } else if (hex.toLowerCase() === "22c55e") {
      // WHES Green
      return "brightness(0) saturate(100%) invert(67%) sepia(92%) saturate(372%) hue-rotate(76deg) brightness(99%) contrast(94%)";
    } else if (hex.toLowerCase() === "1a1a1a") {
      // WHES Dark
      return "brightness(0) saturate(100%) invert(6%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(94%) contrast(106%)";
    } else {
      // Default: create a basic filter (this is a simplified approach)
      const brightness = (r + g + b) / (3 * 255);
      return `brightness(0) saturate(100%) invert(${Math.round(
        brightness * 100,
      )}%)`;
    }
  }

  setCSSVariables(config) {
    if (typeof document !== "undefined") {
      const root = document.documentElement;

      // Set CSS custom properties - Main theme
      root.style.setProperty("--color-primary", config.theme.primary);
      root.style.setProperty("--color-secondary", config.theme.secondary);
      root.style.setProperty("--color-background", config.theme.background);
      root.style.setProperty("--color-foreground", config.theme.foreground);
      root.style.setProperty("--gradient-from", config.theme.gradient.from);
      root.style.setProperty("--gradient-to", config.theme.gradient.to);
      root.style.setProperty("--font-primary", config.fonts.primary);

      // Set Step1-specific colors
      root.style.setProperty(
        "--step1-color-primary",
        config.theme.step1.primary,
      );
      root.style.setProperty(
        "--step1-color-secondary",
        config.theme.step1.secondary,
      );
      root.style.setProperty(
        "--step1-gradient-from",
        config.theme.step1.gradient.from,
      );
      root.style.setProperty(
        "--step1-gradient-to",
        config.theme.step1.gradient.to,
      );

      // Set Step1 button text colors
      root.style.setProperty(
        "--step1-primary-btn-text",
        config.theme.step1.buttonText.primary,
      );
      root.style.setProperty(
        "--step1-secondary-btn-text",
        config.theme.step1.buttonText.secondary,
      );

      // Set Step1 progress bar color
      root.style.setProperty(
        "--step1-progress-bar-color",
        config.theme.step1.progressBar,
      );

      // Set Step1 consultation text color
      root.style.setProperty(
        "--step1-consultation-text",
        config.theme.step1.consultationText,
      );

      // Set purple theme colors (for existing components)
      root.style.setProperty("--purple-primary", config.colors.purple.primary);
      root.style.setProperty("--purple-dark", config.colors.purple.dark);
      root.style.setProperty("--purple-light", config.colors.purple.light);

      // Generate and set brand icon filter based on primary color
      const brandIconFilter = this.hexToFilter(config.theme.primary);
      root.style.setProperty("--brand-icon-filter", brandIconFilter);
    }
  }

  // Language preference methods
  getPreferredLanguage() {
    return this.whitelabelLanguage;
  }

  // Dynamic favicon update
  updateFavicon() {
    // if (typeof document !== "undefined") {
    //   const favicon =
    //     document.querySelector('link[rel="icon"]') ||
    //     document.querySelector('link[rel="shortcut icon"]');
    //   if (favicon) {
    //     favicon.href = this.getFavicon();
    //   } else {
    //     // Create favicon link if it doesn't exist
    //     const newFavicon = document.createElement("link");
    //     newFavicon.rel = "icon";
    //     newFavicon.href = this.getFavicon();
    //     document.head.appendChild(newFavicon);
    //   }
    // }
  }

  // Method to reload configuration (useful for testing and navigation)
  reloadConfiguration() {
    // this.currentPath = this.getCurrentPath();
    // this.config = this.loadConfiguration();
    this.loadRoute();
    return this.config;
  }
}

// Export singleton instance
export default new WhitelabelService();
